
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 导入api文件
import * as $http from './common/api/index'
import utils from './utils.js'
// 引入iconfont的样式
import './assets/iconfont/iconfont.css'
// 引入Vant UI组件的样式
import 'vant/lib/index.css'
// 1.引入axios
import axios from 'axios'
// 微信分享相关
import commom from './commom.js'
// 全局变量
import Global from './Global.js'
// 引入lib-flexible  用于设置 rem 基准值
import 'lib-flexible/flexible'
import '@/styles/index.css'
import md5 from 'js-md5';
import _ from 'lodash'
// minxins混入
import commonMinxins from './common/minxins/common'
import cnzzStat from './common/minxins/cnzzStat'
// 视频组件
import VideoPlayer from 'vue-video-player'
import html2cavas from './html2cavas'
import VueLuckyCanvas from '@lucky-canvas/vue'
import JSEncrypt from 'jsencrypt';
Vue.prototype.$getRsaCode = function(pwd) { // 注册Rsa加密方法
  if (_.isString(pwd)) {
    const pubKey = `-----BEGIN PUBLIC KEY----- MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCBFwwgPfc5QFD21Mtb6k2bVtHZp2tUpk/sw8uhDMDXfbKChF+dPhrbR2GOoBwOFEqr6rmGjxkhk5ELcMANb8D7UCKAT4BILlosIKrA99InOnKBH3tNnyBHq7Lsei4xGUyS/k71UL+Qi41K6fv2q4L0CUtuyhh8nPJ0abCwm1lA/wIDAQAB -----END PUBLIC KEY-----`
    const encrypStr = new JSEncrypt();
    encrypStr.setPublicKey(pubKey); // 设置加密公钥
    const data = encrypStr.encrypt(pwd.toString());
    return data;
  } else {
    return false;
  }
}
Vue.use(VueLuckyCanvas)
Vue.use(html2cavas);
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
// vant组件
import {
  Checkbox,
  CheckboxGroup,
  Button,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  ImagePreview,
  Form,
  Field,
  Popup,
  Picker,
  Toast,
  NoticeBar,
  CountDown,
  Dialog,
  ActionSheet,
  Icon,
  Sticky,
  Image as VanImage} from 'vant'
Vue.prototype.Global = Global
Vue.prototype._ = _;
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(ImagePreview)
Vue.use(utils)
Vue.use(commom)
Vue.use(Button)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popup)
Vue.use(Form)
Vue.use(Field)
Vue.use(NoticeBar)
Vue.use(Picker)
Vue.use(Toast)
Vue.use(CountDown)
Vue.use(Dialog)
Vue.use(VanImage)
Vue.use(VideoPlayer)
Vue.use(ActionSheet)
Vue.use(Icon)
Vue.use(Sticky)
// 挂载api文件
Vue.prototype.$http = $http
Vue.prototype.$md5 = md5
// Vue.prototype.$router = router

// 2.把axios绑定到vue实例的属性$axios
Vue.prototype.$axios = axios

// 混入
Vue.mixin(commonMinxins)
Vue.mixin(cnzzStat)

console.log('start....')

Vue.config.productionTip = false

// 每次路由切换后清除未返回的请求
var axiosPromiseArr = [] //储存cancel token

let vm =  new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.query.uniHm == '1') {
    sessionStorage.setItem('uniHm',to.query.uniHm)
  }
  // axiosPromiseArr.forEach((ele, index) => {
  //   ele.cancel()
  //   delete axiosPromiseArr[index]
  // })
  // if (vm.commom.isWeiXin() && to.path != '/shareexamlist' && to.path != '/shareexamdetail' && to.path != '/studylist' && to.path != '/shareauth' && to.path != '/shareView' && to.path != '/sharepersonview' && to.path != '/peveEpide' && to.path != '/solutionProport') {
  //   if (!(window.location.hash.indexOf('/studylist') != -1 || window.location.hash.indexOf('/shareexamlist') != -1 || window.location.hash.indexOf('/shareexamdetail') != -1)) {
  //     vm.commom.weiXinReady();
  //     Vue.prototype.Global.isShareAllow = false;
  //   }
  // }
  // if (vm.commom.isQQ()) {
  //   vm.commom.qqReady()
  // }
  console.log(to.meta.title,1111)
  document.title = to.meta.title ? to.meta.title : '感控工作间'
  // let taskName =  "快速了解感控工作间";
  // let descs =  "因为爱, 所以感控";
  // let sharePath = ''
  // if(location.href && location.href.split('#')) {
  //   sharePath = location.href.split('#')[0]
  // }
  // if(sharePath) {
  //     vm.commom.weiXinReady(3, descs, taskName, "", "", "", () => {}, sharePath);
  // }
  next()
})
